import { Badge } from '@/components/ui/badge';
import { ClaudeTaskStatus } from '@/types/claudeTask';

interface TaskStatusBadgeProps {
  status: ClaudeTaskStatus | string;
  className?: string;
}

export function TaskStatusBadge({ status, className = '' }: TaskStatusBadgeProps) {
  const getStatusColor = (status: string) => {
    switch (status) {
      case ClaudeTaskStatus.PENDING:
        return 'bg-yellow-100 text-yellow-800 hover:bg-yellow-100';
      case ClaudeTaskStatus.RUNNING:
        return 'bg-blue-100 text-blue-800 hover:bg-blue-100';
      case ClaudeTaskStatus.COMPLETED:
        return 'bg-green-100 text-green-800 hover:bg-green-100';
      case ClaudeTaskStatus.FAILED:
        return 'bg-red-100 text-red-800 hover:bg-red-100';
      default:
        return 'bg-gray-100 text-gray-800 hover:bg-gray-100';
    }
  };

  const getStatusText = (status: string) => {
    switch (status) {
      case ClaudeTaskStatus.PENDING:
        return 'Pending';
      case ClaudeTaskStatus.RUNNING:
        return 'Running';
      case ClaudeTaskStatus.COMPLETED:
        return 'Completed';
      case ClaudeTaskStatus.FAILED:
        return 'Failed';
      default:
        return status;
    }
  };

  return (
    <Badge className={`${getStatusColor(status)} ${className}`}>
      {getStatusText(status)}
    </Badge>
  );
}
